exports.f = require('./_wks');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/core-js/library/modules/_wks-ext.js
 ** module id = 219
 ** module chunks = 0
 **/